module.exports = "/_next/static/images/f201250a147c166e37fa3c0797951569-man-sitting-with-notebook@md-2x.jpg";